<template>
 <div class="assigRulesBox">
   <div class="innerLeft">
     <el-tabs v-model="activeNames"  stretch @tab-click="changeShowNew">
       <el-tab-pane label="Zones" name="first">
         <div class="assigTop">
           <div class="topSeach">
             <div>
               <div style="margin: 0 16px;width: 260px">
                 <el-input v-model="searchName" placeholder="Search..">
                   <div slot="prefix">
                     Name:
                   </div>
                   <div style="clear: both">
                   </div>
                 </el-input>
               </div>
             </div>
             <div style="margin: 0 16px;width: 260px">
               <el-select v-model="searchStatus" placeholder="All">
                 <el-option
                   v-for="item in option"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
                 </el-option>
                 <div slot="prefix" >
                   Status:
                 </div>
                 <div style="clear: both">
                 </div>
               </el-select>
             </div>
           </div>
           <div>
             <el-button type="success" round @click="searchRules" style="width: 80px;padding: 0">Search</el-button>
             <el-button plain @click="clearAll" style="width: 80px" class="changeFocus">Clear</el-button>
           </div>
         </div>
         <div class="topAdd">
           <el-button type="primary" round style="margin-right: 16px;padding: 9px 24px" @click="createZone">NEW</el-button>
         </div>
         <div class="tasksTable"  v-loading="loading">
           <div class="innerTop">
             <div class="outTable"  v-if="assigList.length!= 0">
               <el-table
                 :data="assigList"
                 style="width: 100%;font-weight: normal;">
                 <el-table-column
                   header-align="center"
                   align="center"
                   prop="priority"
                   label="Priority1"
                   min-width="25%"
                 >
                 </el-table-column>
                 <el-table-column
                   prop="name"
                   label="Name"
                   min-width="40%"
                 >
                 </el-table-column>
                 <el-table-column
                   label="Rules"
                 >
                   <template slot-scope="scope">
                     <div class="innerMsg">{{scope.row.rule_desc}}</div>
                     <div  class="innerMsg" style="color: #999999;">{{scope.row.assign_desc}}</div>
                   </template>
                 </el-table-column>
                 <el-table-column
                   label="Status"
                   align="center"
                   width="150px"
                 >
                   <template slot-scope="scope">
                     <div  class="green" v-if="scope.row.status == 1">Active</div>
                     <div class="pend" v-if="scope.row.status == 0">Inactive</div>
                   </template>
                 </el-table-column>
                 <el-table-column
                   header-align="center"
                   align="center"
                   prop="actions"
                   width="150"
                   label="Actions">
                   <template slot-scope="scope">
                     <div class="action">
                       <span  @click="handleDelete(scope.row)">
                          <img src="../assets/image/delete@2x.png" alt="">
                        </span>
                       <span  v-if="scope.row.status == 0" @click="changeRulesStatus(1,scope.row)">
                          <img src="../assets/image/active.png" alt="">
                        </span>
                        <span  v-if="scope.row.status == 1" @click="changeRulesStatus(0,scope.row)">
                          <img src="../assets/image/inactive.png" alt="">
                        </span>
                       <span  @click="handleedit(1,scope.row)">
                        <img src="../assets/image/edit@2x.png" alt="">
                        </span>
                       <span @click="handleedit(2,scope.row)">
                          <img src="../assets/image/clone@2x.png" alt="">
                        </span>
                     </div>
                   </template>
                 </el-table-column>
               </el-table>
             </div>
             <div v-else class="empty">
               <div>
                 <img src="../assets/image/list_blank.png" alt="">
                 <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
               </div>
             </div>
           </div>
         </div>
         <div class="btomPagin" >
           <div class="innerLefts">{{page}} - <span>{{assigList.length}}</span> of <span>{{total}}</span> items</div>
           <div>
             <el-pagination
               :page-size="10"
               layout="prev, pager, next, jumper"
               :total="total"
               @current-change="handleSizeChange"
             >
             </el-pagination>
           </div>
         </div>
       </el-tab-pane>
       <el-tab-pane label="Drivers" name="second">
         <div class="tasksTable"  v-loading="loadings">
           <div class="innerTop">
             <div class="outTable"  v-if="driverData.length!= 0">
               <el-table
                 :data="driverData"
                 style="width: 100%;font-weight: normal;">
                 <el-table-column
                   header-align="center"
                   align="center"
                   prop="name"
                   label="zone"
                   width="150px"
                 >
                 </el-table-column>
                 <el-table-column
                   label="Driver"
                   min-width="40%"
                 >
                   <template slot-scope="scope">
                     <div v-if="scope.row.worker_name!=null" class="innerMsg">{{scope.row.worker_name}}</div>
                     <div v-else style="color: #999999;">No Driver</div>
                   </template>
                 </el-table-column>
                 <el-table-column
                   header-align="center"
                   align="center"
                   prop="actions"
                   width="150"
                   label="Actions">
                   <template slot-scope="scope">
                     <div class="action">
                       <span @click="handelClear(scope.row)">
                          <img src="../assets/image/clear.png" alt="">
                        </span>
                       <span @click="handelEdit(scope.row)">
                          <img src="../assets/image/edit@2x.png" alt="">
                        </span>
                     </div>
                   </template>
                 </el-table-column>
               </el-table>
             </div>
             <div v-else class="empty">
               <div>
                 <img src="../assets/image/list_blank.png" alt="">
                 <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
               </div>
             </div>
           </div>
         </div>
         <div class="btomPagin" >
                  <div class="innerLefts">{{page1}} - <span>{{driverData.length}}</span> of <span>{{total1}}</span> items</div>
                  <div>
                    <el-pagination
                      :page-size="10"
                      layout="prev, pager, next, jumper"
                      :total="total1"
                      @current-change="handleSizeChange1"
                    >
                    </el-pagination>
                  </div>
                </div>
       </el-tab-pane>
     </el-tabs>
   </div>
<!--新增编辑zone弹框-->
   <el-dialog
     :close-on-click-modal="false"
     style="padding-top: 0"
     :title=title
     :visible.sync="createDialog"
     top="5vh"
     @close="closeClear"
     width="35%">
     <div>
       <el-form :model="innerForm" label-position="top" :rules="assigRulesForm" status-icon ref="perTasksRef" :show-message="false">
          <el-form-item label="Priority" required prop="priority">
            <el-input placeholder="Priority number" v-model="innerForm.priority"></el-input>
          </el-form-item>
         <el-form-item label="Name of rule" required prop="name">
           <el-input placeholder="Name" v-model="innerForm.name"></el-input>
         </el-form-item>
         <el-form-item label="Rules" required>
           <div class="formInForm">
             <el-form :model="innerForm" label-position="top" status-icon  :show-message="false">
               <el-form-item label="Organization">
                 <el-select v-model="innerForm.organization_id" placeholder="Select an organization" @change="changeOra">
                   <el-option
                     v-for="item in oraOptions"
                     :key="item.id"
                     :label="item.organization_name"
                     :value="item.id">
                   </el-option>
                 </el-select>
               </el-form-item>
               <el-form-item label="Store">
                 <el-select v-model="innerForm.sub_organization_id" placeholder="Select an store" :disabled="storeDisabled">
                   <el-option
                     v-for="item in storeOptions"
                     :key="item.id"
                     :label="item.sub_organization_name"
                     :value="item.id">
                   </el-option>
                 </el-select>
               </el-form-item>
               <el-form-item label="Task path">
                 <el-select v-model="innerForm.task_path" placeholder="Select a path">
                   <el-option
                     v-for="item in pathOptions"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
                   </el-option>
                 </el-select>
               </el-form-item>
               <el-form-item label="Task type">
                 <el-select v-model="innerForm.task_type" placeholder="Select a task type">
                   <el-option
                     v-for="item in typeOptions"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
                   </el-option>
                 </el-select>
               </el-form-item>
               <div class="innerText">
                 <div class="innerUpload">
                   <el-upload
                     class="upload-demo"
                     :action="actionUrl"
                     :headers="config"
                     :http-request="httpRequest"
                     :show-file-list="false"
                   >
                     <img src="../assets/image/upload.png" alt="">
                   </el-upload>

                 </div>
                 <el-form-item label="Zip Codes">
                   <div class="outZip" @click="focusOn">
                       <el-tag
                         v-for="tag in tags"
                         :key="tag.name"
                         closable
                         @close="handleClose(tag)"
                         :type="tag.type">
                         {{tag.name}}
                       </el-tag>
                     <div class="innerInput">
                       <input type="text"
                              ref="inputs"
                              v-model="zipCode"
                              @keyup.delete="deleteTag"
                              onkeydown="this.onkeyup();"
                              onkeyup="this.size=(this.value.length>4?this.value.length:2);"
                              size="2">
                     </div>
                   </div>
                 </el-form-item>
               </div>
             </el-form>
           </div>
         </el-form-item>
         <el-form-item :label="changeLabel" required>
           <el-select v-model="innerForm.zone" placeholder="Select a Zone">
             <el-option
               v-for="item in storeOption"
               :key="item.id"
               :label="item.name"
               :value="item.id">
             </el-option>
           </el-select>
         </el-form-item>
       </el-form>
     </div>
     <span slot="footer" class="dialog-footer">
<!--    <el-button type="primary" plain >Cancel</el-button>-->
         <el-button type="danger"  @click="cancelCreate" plain>Cancel</el-button>
    <el-button type="primary" @click="confirmCreate" round>Save</el-button>
  </span>
   </el-dialog>
<!--   删除弹框-->
   <el-dialog
     :close-on-click-modal="false"
     :title="deleteTitle"
     :visible.sync="dialogVisible"
     width="30%">
     <div style="margin-top: 24px" v-if="deleteTitle == 'Delete rule'">The rule named {{ruleName}} will be permanently deleted.</div>
     <div style="margin-top: 24px" v-else>The driver for {{zoneName}} will be cleared.</div>
     <span slot="footer" class="dialog-footer">
     <el-button type="danger" @click="dialogVisible = false" plain>Cancel</el-button>
    <el-button type="primary" @click="deleteSuccess">Delete</el-button>
  </span>
   </el-dialog>
<!--  编辑司机弹框-->
   <el-dialog
     :close-on-click-modal="false"
     :title="editDriverTitle"
     :visible.sync="driverDialogVisible"
     width="30%">
     <div style="margin-top: 24px">
       <el-select v-model="driverGroup" placeholder="Select an driver group" @change="changeGroup">
         <el-option
           v-for="item in groupOptions"
           :key="item.id"
           :label="item.name"
           :value="item.id">
         </el-option>
       </el-select>
       <div style="margin-top: 16px">
         <el-select v-model="driver" placeholder="Select a driver" :disabled="disabled">
           <el-option
             v-for="item in driverOptions"
             :key="item.id"
             :label="item.name"
             :value="item.id">
           </el-option>
         </el-select>
       </div>
     </div>
     <span slot="footer" class="dialog-footer">
     <el-button type="danger" @click="driverDialogVisible = false" plain>Cancel</el-button>
    <el-button type="primary" @click="saveSuccess">Save</el-button>
  </span>
   </el-dialog>
 </div>
</template>

<script>
import {
  addNewRules,
  changeStatus,
  clearZone,
  deleteRuleData,
  editZone, eidtNewRules, exporeCode,
  getRulesList,
  getZoneList
} from "@/api/assigRules";
import { getGroupList} from "@/api/driver";
import {getDriverList} from "@/api/tasks";
import {getOraList, getStoreList} from "@/api/organization";
import {getAvatar} from "@/api/login";
import {uploadPerTask} from "@/api/preTask";

export default {
  name: "assigRules",
  computed: {
    config() {
      return { token: this.token };
    },
  },
  data(){
    return{
      actionUrl: process.env.VUE_APP_BASE_URL,
      searchName:'',
      searchStatus:'',
      option:[
        {name:'All',id:"all"},
        {name:'Inactive',id:0},
        {name:'Active',id:1},
      ],
      loading:false,
      assigList:[],
     page:1,
     total:0,
      createDialog:false,
      ruleForm:{},
      assigRulesForm:{
        priority: [
          { required: true, message: '', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      title:'Create an assignment rule',
      innerRulesForm:{},
      innerForm:{
        name:'',
        priority: '',
        organization_id:'',
        sub_organization_id:"",
        task_path:"",
        task_type:"",
        zone:"",
      },
      storeOptions:'',
      oraOptions:[],
      pathOptions:[
        {name:'Scanning',id:1},
        {name:'Manually',id:2},
        {name:"Pre-tasks",id:3},
      ],
      typeOptions:[
        {name:'Pickup',id:0},
        {name:'Dropoff',id:1},
      ],
      stored:'',
      storeOption:[],
      tags: [],
      zipCode:'',
      activeNames:'first',
      driverData:[],
      page1:1,
      total1:0,
      loadings:false,
      deleteTitle:'Delete rule',
      dialogVisible:false,
      ruleName:'',
      ruleId:'',
      zoneName:'',
      zoneId:'',
      driverDialogVisible:false,
      editDriverTitle:'',
      driverGroup:'',
      driverOptions:[],
      groupOptions:[],
      driver:'',
      disabled:false,
      editId:'',
      storeDisabled:true,
      changeLabel:' Sorted to',
      flage:true,
    }
  },
  watch:{
    zipCode: {
      deep: true,
      handler: function (n, o) {
        // 输入逗号，生成标签
        if (n.indexOf(',') > -1) {
            this.zipCode = this.zipCode.split(',')[0];
            this.tags.push({name:this.zipCode})
          this.zipCode = ""
        }
      },
    },
  },
  created() {
    //获取列表
    this.getRuleDtata()
    this.getDriverGroup()
    this.getOraData()
    getZoneList({
      page:1,
      limit:100
    }).then(res=>{
      this.loadings = false
      if (res.code == '200'){
        this.storeOption = res.data.data
        this.driverData = res.data.data
        this.total1 = res.data.count
      }else {
        this.$message({
          message: res.data.msg,
          type: 'warning',
        });
      }
    }).catch(err=>{
      this.$message({
        message: err.data.msg,
        type: 'warning',
      });
    })
  },
  methods:{
    createZone(){
      this.createDialog = true
      this.title = 'Create an assignment rule'
      this.changeLabel = 'Sorted to'
    },
    //获取组织接口
    getOraData(){
      getOraList({
        page:1,
        limit:''
      }).then(res=>{
        if (res.code == 200){
          this.oraOptions = res.data.data
        }
      })
    },
    //获取司机 group
    getDriverGroup(){
      getGroupList({
        page:1,
        limit:'',
      }).then(res=>{
        if (res.code == 200){
          this.groupOptions = res.data.data
        }else {
        }
      }).catch(err=>{
        this.$message({
          message:err.mag,
          type:'error'
        })
      })
    },

    getRuleDtata(){
      this.loading = true
      getRulesList({
        page:this.page,
        limit:10,
        name:this.searchName,
        status:this.searchStatus
      }).then(res=>{
        this.loading = false
        if (res.code == '200'){
          this.assigList = res.data.data
          this.total = res.data.count
        }else {
          this.$message({
            message: res.data.msg,
            type: 'warning',
          });
        }
      }).catch(err=>{
        this.$message({
          message: err.data.msg,
          type: 'warning',
        });
      })
    },
    getZonleData(){
      this.loadings = true
      getZoneList({
        page:this.page1,
        limit:10,
      }).then(res=>{
        this.loadings = false
        if (res.code == '200'){
          this.storeOption = res.data.data
          this.driverData = res.data.data
          this.total1 = res.data.count
        }else {
          this.$message({
            message: res.data.msg,
            type: 'warning',
          });
        }
      }).catch(err=>{
        this.$message({
          message: err.data.msg,
          type: 'warning',
        });
      })

    },
    searchRules(){
      this.page = 1
      this.getRuleDtata()
    },
    clearAll(){
      this.searchStatus = ''
      this.searchName = ""
      this.getRuleDtata()
    },
    handleCurrentChange(){

    },
    handleedit(n,val){
      let a = val
      // this.innerForm.pathOptions = a.pathOptions
      // this.typeOptions = a.typeOptions
      // this.innerForm.storeOption = a.storeOption
      if (a.organization_id!=''){
        this.changeOra(a.organization_id)
      }else {
        this.storeDisabled = true
      }
      // val.storeOptions = this.innerForm.storeOptions
      a.oraOptions = this.oraOptions
      this.tags = a.zip_code.map(i=>({name:i}))
      this.innerForm = {...a}
      this.innerForm.zone = Number(a.zone)
      this.createDialog = true
      if  (n == 1){
        //编辑
        this.title ='Edit an assignment rule'
        this.changeLabel = ' Assign to'
      }else if (n ==2){
        //克隆
        this.title = 'Clone a sort rule'
      }
    },
    //删除zone
    handleDelete(row){
      this.ruleId = row.id
      this.ruleName = row.name
      this.dialogVisible = true
    },
    deleteSuccess(){
      if (this.deleteTitle == 'Delete rule'){
        deleteRuleData({
          id:this.ruleId
        }).then(res=>{
          if (res.code == 200){
            this.dialogVisible = false
            this.$message({
              type:'success',
              message:'Rule has been deleted'
            })
            this.getRuleDtata()
          }else {
            this.$message({
              type:'warning',
              message:res.msg
            })
          }
        })
      }else {
        clearZone({
          id:this.zoneId
        }).then(res=>{
          this.dialogVisible = false
          if (res.code == 200){
            this.$message({
              type:'success',
              message:'Driver has been cleared'
            })
            this.getZonleData()
          }else {
            this.$message({
              type:'warning',
              message:res.msg
            })
          }
        })
      }
    },
    cancelCreate(){
      this.createDialog = false
    },

    validateForm() {
      let flag = false
      this.$refs['perTasksRef'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    confirmCreate(){
      this.validateForm()
      // this.confirmNull(this.innerForm)
      let arr = this.innerForm
      let obj = true
      Object.keys(arr).forEach(i=>{
        if( arr[i] === ""){
          obj = false
        }else {
        }
      })
      if (this.validateForm() && obj && this.tags.length !=0){
        let arr = []
        this.tags.forEach(i=>{
          arr.push(i.name)
        })
        this.innerForm.zip_code =arr
        if (this.title =='Edit an assignment rule'){
          eidtNewRules(this.innerForm).then(res=>{
            if (res.code == 200){
              this.$message({
                type:"success",
                message:res.msg
              })
              this.createDialog = false
              this.getRuleDtata()
            }else {
              this.$message({
                type:"error",
                message:res.msg
              })
            }
          })
        }else {
          addNewRules(this.innerForm).then(res=>{
            if (res.code == 200){
              this.$message({
                type:"success",
                message:res.msg
              })
              this.createDialog = false
              this.getRuleDtata()
            }else {
              this.$message({
                type:"error",
                message:res.msg
              })
            }
          })
        }
      }else {
       this.$message({
         type:'warning',
         message:"Some information missing"
       })
      }

    },
    //在input失去焦点时 按照comma 转化成标签
    changeTag(){

    },
    focusOn(){
      this.$refs.inputs.focus()
    },
    handleClose(val){
      this.tags.splice(this.tags.indexOf(val), 1);
      this.$refs.inputs.focus()
    },
    //监听删除
    deleteTag(e){
      // if (this.zipCode == ''){
      //   this.tags.pop()
      //   this.$refs.inputs.focus()
      // }else {
      //
      // }
    },
    changeShowNew(){
      if (this.activeNames == 'first'){
        this.getRuleDtata()
      }else if (this.activeNames == 'second') {
        this.getZonleData()
      }
    },
    handleSizeChange(val){
      this.page = val
      this.getRuleDtata()
    },
    handleSizeChange1(val){
      this.page1 = val
      this.getZonleData()
    },
    handelClear(val){
      this.deleteTitle = 'Clear the driver for' + val.name
      this.zoneName = val.name
      this.zoneId = val.id
      this.dialogVisible = true
    },
    handelEdit(row){
      this.editDriverTitle = 'Edit a driver for' + row.name
      this.editId = row.id
      if (this.driverGroup == ''){
        this.disabled = true
      }else {
        this.disabled = false
      }
      this.driverDialogVisible = true
    },
    changeGroup(id){
      this.disabled = false
      getDriverList({
        group_id:id
      }).then(res=>{
        if (res.code == 200){
          this.driverOptions = res.data
        }
      })
    },
    saveSuccess(){
      editZone({
        id:this.editId,
        group_id:this.driverGroup,
        worker_id:this.driver
      }).then(res=>{
        if (res.code == 200){
          this.$message({
            type:'success',
            message:'Edited Successfully',
          })
          this.driverDialogVisible = false
          this.getZonleData()
        }
      })
    },
    changeRulesStatus(status,row){
      changeStatus({
        id:row.id,
        status:status,
      }).then(res=>{
        if (res.code == 200){
          this.$message({
            type :'success',
            message:res.msg
          })
          this.getRuleDtata()
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      })
    },
   changeOra(val){
     getStoreList({
       page:1,
       id:val,
     }).then(res=>{
       this.storeDisabled = false
       this.storeOptions = res.data.data
     })
   },
    closeClear(){
      this.$refs.perTasksRef.resetFields()
      this.innerForm={}
      this.$refs['perTasksRef'].clearValidate()
      this.tags = []
      this.storeDisabled = true
    },
    httpRequest(data){
      let _this = this
      let formData = new FormData()
      formData.append('file', data.file)
      // formData.append('sub_organization_id', this.$store.state.store)
      exporeCode(formData).then(res=>{
        if (res.code == 200) {
          this.tags = res.data.map(i=>({name:i}))
        } else {
          _this.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      }).catch(err=>{
      })
      // }

    },

  }
}
</script>

<style scoped lang="less">
.assigRulesBox{
  .assigTop{
    padding: 16px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #E0E0E0;
    display: flex;
    justify-content: space-between;
    /deep/.changeFocus:focus{
      border: 1px solid #DCDFE6;
      color: #606266;
    }
    .topSeach{
      display: flex;
      /deep/ .el-input--prefix .el-input__inner{
        padding-left: 88px;
      }
      /deep/ .el-input__prefix{
        color: #1F2D42;
      }
    }

  }
  .topAdd{
    text-align: right;
    margin: 16px 0;
  }

  .tasksTable{
    margin-top: 16px;
    font-weight: normal;
    font-size: 13px;

    .innerTop{
      .outTable{
        margin-top: 17px;
        //height: 58vh;
        //overflow: auto;
        .action{
          span{
            cursor: pointer;
          }
          img{
            width: 16px;
            margin-right: 16px;
          }
        }
        .green{
          padding: 0 16px;
          line-height: 22px;
          background: #82D237;
          border-radius: 11px;
          text-align: center;
          font-weight: bold;
          color: #FFFFFF;
          display: inline-block;
        }
        .pend{
          padding: 0 16px;
          line-height: 22px;
          background:#BCBEBF;
          border-radius: 11px;
          text-align: center;
          font-weight: bold;
          color: #FFFFFF;
          display: inline-block;
        }
        .innerMsg{
          max-width: 80%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .btomPagin{
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        padding-left: 16px;
        .innerLeft{
          font-size: 16px;
          font-family: SFPro-Regular, SFPro;
          font-weight: 400;
          color: #1F2D42;
          line-height: 20px;
        }
      }
    }
    .empty{
      width: 200px;
      height: 387px;
      margin: 20px auto;
      position: relative;
      img{
        width: 100%;
        height: 200px;
      }
      div{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .footers{
    width:calc( 100% - 72px);
    z-index: 2;
    height: 64px;
    background: #1F2D42;
    position: fixed;
    bottom: 0;
    margin-left: -32px;
    line-height: 64px;
    display: flex;
    justify-content: space-between;
    padding-right: 48px;
    padding-left: 32px;
    color: #FFFFFF;
  }
  .formInForm{
    margin-left: 32px;
    margin-top: -16px;
    border-bottom: 1px solid #D8D8D8;
    padding-bottom: 16px;
    .innerText{
      position: relative;
      /deep/ .el-textarea__inner{
        height: 132px;
      }
      .innerUpload{
        position: absolute;
        right: 16px;
        img{
          width: 16px;
          height: 16px;
          margin: 16px 0;
        }
      }
      .outZip{
        height: 132px;
        background: #FFFFFF;
        border-radius: 16px;
        border: 1px solid #E0E0E0;
        padding: 8px;
        cursor: pointer;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow: auto;
        /deep/.el-tag{
          height: 24px;
          line-height: 24px;
          background: #F5F6FB;
          border-radius: 12px;
          font-size: 12px;
          font-weight: bold;
          color: #1F2D42;
          padding: 0 12px;
          border: none;
          margin: 0 4px;
          i{
            color: #A3A4A4;
          }:hover{
          background-color: #3A4659;
          color: #FFFFFF;
                     }
        }
        .innerTag{
          //position: absolute;
          z-index: 999;
        }
        .innerInput{
          min-width: 20px;
          flex-wrap: wrap;
        }
        input{
          border: none;
          box-shadow: none;
          outline: none;
          background-color: transparent;
          padding: 0 10px;
          margin: 0;
          vertical-align: top;
          height: 30px;
          color: #34495e;
        }
      }
      .outZip:hover{
               border: 1px solid #C0C4CC;
             }
    }
  }
  .innerLeft{
    width: 288px;
    font-size: 14px;
    font-weight: 400;
    color: #1F2D42;
    height: 32px;
    line-height: 32px;
    border-radius: 16px;
    background: #ECECF2;
    /deep/.el-tabs__content{
      width: calc(100vw - 248px);
    }
    /deep/ .el-tabs__nav-scroll{
      padding-left: 0;
    }
    /deep/  .el-tabs__nav-wrap::after{
      background: none ;
    }
    /deep/  .el-tabs__item{
      height: 32px;
      line-height: 32px;
      flex: 1;
    }
    /deep/ .el-tabs__item.is-active{
      background: #E95646;
      color: #FFFFFF;
      border-radius: 16px;
    }

    /deep/.el-tabs__active-bar {
      background: none;
    }
    .btomPagin{
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      padding-left: 16px;
      .innerLefts{
        font-size: 16px;
        font-family: SFPro-Regular, SFPro;
        font-weight: 400;
        color: #1F2D42;
        line-height: 20px;
      }
    }
  }
}
</style>
